import React from 'react';
import PresentationArrow from '../PresentationArrow';
import PresentationName from '../PresentationName';
import './styles.css'

export default function Presentation () {

    return (
        <div className='presentation component'>
            <div className='scroll-down'>
                <div className='arrow-scroll'>
                    <PresentationArrow/>
                </div>
            </div>
            <PresentationName/>

        </div>
    )
}